<template>
  <div class="GEmanage">
    <div style="padding:0 30px 20px 0;">
      <el-button type="primary" @click="go('personal_center_addGE')">新 增</el-button>
    </div>
    
    <myTable :tableObj="tableObj" @btnClick="btnClick" @changePageNo="changePage"></myTable>
   
  </div>
</template>

<script>
import myTable from "@/components/my_table";
export default {
  components: {
    myTable
  },
  data() {
    return {
      row:null,//临时操作对象
      tableObj: {
        list: [], //列表数据
        btnsWidth:'100px',
        btns: [
          //按钮组
          {
            name: "查看",
            funcName: "see"
          },
           {
            name: "编辑",
            funcName: "edit"
          },
           {
            name: "作品管理",
            funcName: "manage"
          },
        ],
        table_detail: [
          {
            width:'100px',
            prop: "year",
            label: "年份"
          },
          {
            prop: "name",
            label: "展会名称"
          },
          {
             width:'200px',
            label: "主视觉海报",
            formatter(row){
              return `<div><img style="height:72px;" src="${row.coverPath}"/></div>`
            }
          },
          {
            width:'70px',
            label: "状态",
            formatter(row){
              let _text = '';
              if(row.type_2020 === true){
                _text = row.status_name
              }else{
                _text = '已通过'
              }
              return _text
            }
          },
        ],
        layerpageinfo: {
          pageNo: 0,
          total: 0,
          pageSize: 10
        }
      }
    };
  },
  computed: {
    info() {
      return this.$store.state.info;
    },
    designer() {
      return this.$store.state.designer;
    }
  },
  created() {
    if (this.designer) {
      this.getFrontExhibitions();
    } else {
      this.needInfo("designer", "getFrontExhibitions");
    }
  },
  methods: {
    go(name){
      this.$router.push({
        name:name
      })
    },
    /* 监测信息 */
    needInfo(name, fn) {
      let watchAch = this.$watch(name, (val, oldVal) => {
        if (val) {
          this[fn]();
          watchAch(); //取消监听
        }
      });
    },
    // 展会列表
    getFrontExhibitions() {
      let params = Object.assign({}, this.tableObj.layerpageinfo, {
        school: this.designer.id
      });
      return new Promise(resolve => {
        this.api.getFrontExhibitions(params).then(res => {
          if (res.error.err_code !== 0) return;
          this.tableObj.list = res.obj.list || [];
          this.tableObj.layerpageinfo.total = res.obj.totalSize;
          resolve();
        });
      });
    },
    // 按钮组
    btnClick(btn) {
      this.row = btn.row;
      switch (btn.btnFuncName) {
        case "see":
          this.$router.push({
            name: "personal_center_GEdetail",
            query: {
              id: btn.row.id,
              code:btn.row.code
            }
          });
          break;
        case "edit":
          this.$router.push({
            name: "personal_center_addGE",
            query: {
              id: btn.row.id,
              code:btn.row.code
            }
          });
          break;  
         case "manage":
          this.$router.push({
            name: "personal_center_mange_work",
            query: {
              id: btn.row.id,
              code:btn.row.code,
            }
          });
          break;  
      }
    },
   
    // 改变页数
    changePage(obj) {
      this.tableObj.layerpageinfo.pageNo = obj.val;
      this.getFrontExhibitions();
    }
  }
};
</script>

<style lang="scss" scoped>
.GEmanage {
  padding:20px 20px;
  background: #fff;
}
</style>